module.exports = __webpack_public_path__ + "img/1N.a8c83786.jpg";